import styled from 'styled-components';

import ContentSection from 'components/ContentSection';
import { colorBlack900, fontFamilySecondary } from 'styles/variables';

export const Wrapper = styled.div`
  margin-top: 0;
`;
export const Blocks = styled(ContentSection)``;
export const Title = styled.h2`
  font-size: 20px;
  line-height: 28px;
  color: ${colorBlack900};
  font-family: ${fontFamilySecondary};
  margin-bottom: 16px;
`;
